import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MediosComponent} from '../medios.component'
//Services
import {TransmediaService} from 'src/app/core/services/parameters/transmedia.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditarMedioModal implements OnInit {

  editMedioForm: FormGroup;
  loading = false;
  showAlert = false;
  medioId;
  medioData = {
    id: '',
    createdAt: ''
  };

  constructor(
    public dialogRef: MatDialogRef<MediosComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private transmediaService: TransmediaService
  ) {
  }

  ngOnInit(): void {
    this.editMedioForm = this.fb.group({
      medio: [, Validators.required]
    })
    this.medioId = this.data.id;
    this.transmediaService.getTransmediaById(this.medioId).subscribe(_res => {
      this.medioData = _res;
      this.editMedioForm.patchValue({
        medio: _res.name
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editMedioForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editMedioForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.medio
      }
      this.transmediaService.updateTransmedia(this.medioId, data).subscribe(_res => {
        this.alert.setNotice('Medio actualizado correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo actualizar el medio', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
